export default __webpack_public_path__ + "static/media/453.baea2d85.png";